import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import AnnouncementBar from './AnnouncementBar';

const AppLayout = () => {
  return (
    <Box sx={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AnnouncementBar />
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default AppLayout;
